
const track = document.querySelector('.slideshow');
const slides = document.querySelectorAll('.banner-slide');

  let currentIndex = 0;
  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID;
  let slideWidth = track.clientWidth;


  function changeSlide(targetIndex, blockId) {
    currentIndex = targetIndex;
    updateSlidePosition();
    setPositionByIndex();
    changeActiveControl(currentIndex);
  }

  function updateSlidePosition() {
    track.style.transition = 'transform 0.3s ease';
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  function setPositionByIndex() {
    currentTranslate = -currentIndex * slideWidth;
    prevTranslate = currentTranslate;
    setSliderPosition();
  }

  function setSliderPosition() {
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function animation() {
    setSliderPosition();
    if (isDragging) {
      track.style.transition = 'none';
      requestAnimationFrame(animation);
    }
  }

  function touchStart(index) {
    return function (event) {
      isDragging = true;
      startPos = getPositionX(event);
      animationID = requestAnimationFrame(animation);
      track.style.cursor = 'grabbing';
    };
  }

  function touchMove(event) {
    if (!isDragging) return;
    const currentPosition = getPositionX(event);
    const diff = currentPosition - startPos;
    currentTranslate = prevTranslate + diff;
  }

  function touchEnd() {
    cancelAnimationFrame(animationID);
    updateSlidePosition();
    isDragging = false;
    const movedBy = currentTranslate - prevTranslate;
    if (movedBy < -50 && currentIndex < slides.length - 1) {
      currentIndex += 1;
      changeActiveControl(currentIndex);
    } else if (movedBy > 50 && currentIndex > 0) {
      currentIndex -= 1;
      changeActiveControl(currentIndex);
    }else{
      currentIndex = 0;
      changeActiveControl(currentIndex);
    }
    setPositionByIndex();
    track.style.cursor = 'grab';
  }

  function getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }

  slides.forEach((slide, index) => {
    slide.addEventListener('touchstart', touchStart(index));
    slide.addEventListener('touchmove', touchMove);
    slide.addEventListener('touchend', touchEnd);

    slide.addEventListener('mousedown', touchStart(index));
    slide.addEventListener('mousemove', touchMove);
    slide.addEventListener('mouseup', touchEnd);
    slide.addEventListener('mouseleave', () => {
      if (isDragging) touchEnd();
    });

    slide.addEventListener('dragstart', (e) => e.preventDefault());
  });